import { render, staticRenderFns } from "./set_rotation_song.vue?vue&type=template&id=183e313d"
import script from "./set_rotation_song.vue?vue&type=script&lang=js"
export * from "./set_rotation_song.vue?vue&type=script&lang=js"
import style0 from "./set_rotation_song.vue?vue&type=style&index=0&id=183e313d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports